export const messages = {
  en: {
    advertManage: {
      search: {
        title: 'Search Conditions',
        hide: 'Hide',
        more: 'More',
        adNamePlaceholder: 'Please enter the advertisement name',
        classifyPlaceholder: 'Please select the advertisement category',
        locationPlaceholder: 'Please select the placement location'
      },
      list: {
        title: 'Advertisement Information',
        publish: 'Publish',
        viewAdvert: 'View Advertisement'
      },
      table: {
        advertId: 'Advertisement ID',
        adName: 'Advertisement Name',
        classify: 'Advertisement Category',
        location: 'Placement Location',
        advertType: 'Publish Type',
        startTime: 'Start Time',
        endTime: 'End Time',
        createTime: 'Creation Time'
      },
      advertType: {
        site: 'Site',
        outside: 'Outside',
        noJump: 'No Jump'
      },
      location:{
        device: 'Device',
        ownerHome: 'Owner Home',
        businessHome: 'Business Home',
        serviceHome: 'Service Home',
        convenienceHome: 'Convenience Home',
        staffHome: 'Staff Home'
      },
      classify: {
        logistics: 'Logistics',
        catering: 'Catering',
        travel: 'Travel',
        hotel: 'Hotel',
        education: 'Education',
        internet: 'Internet'
      },
      add: {
        title: 'Publish Advertisement',
        adName: 'Advertisement Name',
        adNamePlaceholder: 'Required, please enter the advertisement name',
        classify: 'Advertisement Category',
        classifyPlaceholder: 'Required, please select the advertisement category',
        locationTypeCd: 'Placement Location',
        locationPlaceholder: 'Required, please select the placement location',
        advertType: 'Publish Type',
        advertTypePlaceholder: 'Required, please select the publish type',
        pageUrl: 'Jump Path',
        pageUrlPlaceholder: 'Please enter the jump path',
        seq: 'Play Order',
        seqPlaceholder: 'Required, please enter the play order',
        startTime: 'Start Time',
        startTimePlaceholder: 'Required, please select the start time',
        endTime: 'End Time',
        endTimePlaceholder: 'Required, please select the end time',
        viewType: 'Play Method',
        viewTypePlaceholder: 'Required, please select the play method',
        image: 'Image (800 * 373)',
        success: 'Advertisement published successfully'
      },
      edit: {
        title: 'Edit Advertisement',
        adName: 'Advertisement Name',
        adNamePlaceholder: 'Required, please enter the advertisement name',
        classify: 'Advertisement Category',
        classifyPlaceholder: 'Required, please select the advertisement category',
        locationTypeCd: 'Placement Location',
        locationPlaceholder: 'Required, please select the placement location',
        advertType: 'Publish Type',
        advertTypePlaceholder: 'Required, please select the publish type',
        pageUrl: 'Jump Path',
        pageUrlPlaceholder: 'Please enter the jump path',
        seq: 'Play Order',
        seqPlaceholder: 'Required, please enter the play order',
        startTime: 'Start Time',
        startTimePlaceholder: 'Required, please select the start time',
        endTime: 'End Time',
        endTimePlaceholder: 'Required, please select the end time',
        viewType: 'Play Method',
        viewTypePlaceholder: 'Required, please select the play method',
        image: 'Image (800 * 373)',
        success: 'Advertisement updated successfully'
      },
      delete: {
        title: 'Confirm Operation',
        confirm: 'Are you sure to delete this advertisement?',
        success: 'Advertisement deleted successfully'
      },
      machine: {
        title: 'Advertisement Device Code',
        machineCode: 'Device Code',
        machineCodePlaceholder: 'Required, please enter the device code',
        view: 'View Advertisement'
      },
      validate: {
        adNameRequired: 'Advertisement name is required',
        classifyRequired: 'Advertisement category is required',
        locationRequired: 'Placement location is required',
        advertTypeRequired: 'Publish type is required',
        seqRequired: 'Play order is required',
        seqNumber: 'Play order must be a number',
        startTimeRequired: 'Start time is required',
        endTimeRequired: 'End time is required',
        viewTypeRequired: 'Play method is required',
        imageRequired: 'Please upload image',
        machineCodeRequired: 'Device code is required'
      },
      fetchError: 'Failed to get advertisement list',
      fetchLocationError: 'Failed to get location types'
    }
  },
  zh: {
    advertManage: {
      search: {
        title: '查询条件',
        hide: '隐藏',
        more: '更多',
        adNamePlaceholder: '请输入广告名称',
        classifyPlaceholder: '请选择广告分类',
        locationPlaceholder: '请选择投放位置'
      },
      list: {
        title: '广告信息',
        publish: '发布',
        viewAdvert: '查看广告'
      },
      table: {
        advertId: '广告ID',
        adName: '广告名称',
        classify: '广告分类',
        location: '投放位置',
        advertType: '发布类型',
        startTime: '投放时间',
        endTime: '结束时间',
        createTime: '创建时间'
      },
      advertType: {
        site: '站内',
        outside: '站外',
        noJump: '不跳转'
      },
      location:{
        device: '设备',
        ownerHome: '业主家',
        businessHome: '商家家',
        serviceHome: '服务家',
        convenienceHome: '便利家',
        staffHome: '员工'
      },
      classify: {
        logistics: '物流',
        catering: '餐饮',
        travel: '旅游',
        hotel: '酒店',
        education: '教育',
        internet: '互联网'
      },
      add: {
        title: '发布广告',
        adName: '广告名称',
        adNamePlaceholder: '必填，请填写广告名称',
        classify: '广告分类',
        classifyPlaceholder: '必填，请选择广告分类',
        locationTypeCd: '投放位置',
        locationPlaceholder: '必填，请选择投放位置',
        advertType: '发布类型',
        advertTypePlaceholder: '必填，请选择发布类型',
        pageUrl: '跳转路径',
        pageUrlPlaceholder: '请填写跳转路径',
        seq: '播放顺序',
        seqPlaceholder: '必填，请填写播放顺序',
        startTime: '投放时间',
        startTimePlaceholder: '必填，请填写投放时间',
        endTime: '结束时间',
        endTimePlaceholder: '必填，请填写结束时间',
        viewType: '播放方式',
        viewTypePlaceholder: '必填，请选择播放方式',
        image: '图片(800 * 373)',
        success: '广告发布成功'
      },
      edit: {
        title: '修改广告',
        adName: '广告名称',
        adNamePlaceholder: '必填，请填写广告名称',
        classify: '广告分类',
        classifyPlaceholder: '必填，请选择广告分类',
        locationTypeCd: '投放位置',
        locationPlaceholder: '必填，请选择投放位置',
        advertType: '发布类型',
        advertTypePlaceholder: '必填，请选择发布类型',
        pageUrl: '跳转路径',
        pageUrlPlaceholder: '请填写跳转路径',
        seq: '播放顺序',
        seqPlaceholder: '必填，请填写播放顺序',
        startTime: '投放时间',
        startTimePlaceholder: '必填，请填写投放时间',
        endTime: '结束时间',
        endTimePlaceholder: '必填，请填写结束时间',
        viewType: '播放方式',
        viewTypePlaceholder: '必填，请选择播放方式',
        image: '图片(800 * 373)',
        success: '广告修改成功'
      },
      delete: {
        title: '请确认您的操作',
        confirm: '确定删除发布广告?',
        success: '广告删除成功'
      },
      machine: {
        title: '广告设备码',
        machineCode: '设备编码',
        machineCodePlaceholder: '必填，请填写设备编码',
        view: '查看广告'
      },
       validate: {
        adNameRequired: 'Advertisement name is required',
        classifyRequired: 'Advertisement category is required',
        locationRequired: 'Placement location is required',
        advertTypeRequired: 'Publish type is required',
        seqRequired: 'Play order is required',
        seqNumber: 'Play order must be a number',
        startTimeRequired: 'Start time is required',
        endTimeRequired: 'End time is required',
        viewTypeRequired: 'Play method is required',
        imageRequired: 'Please upload image',
        machineCodeRequired: 'Device code is required'
      },
fetchError: '获取广告列表失败',
      fetchLocationError: '获取位置类型失败'
    }
  },
  'zh-TW': {
    advertManage: {
      search: {
        title: '查詢條件',
        hide: '隱藏',
        more: '更多',
        adNamePlaceholder: '請輸入廣告名稱',
        classifyPlaceholder: '請選擇廣告分類',
        locationPlaceholder: '請選擇投放位置'
      },
      list: {
        title: '廣告信息',
        publish: '發布',
        viewAdvert: '查看廣告'
      },
      table: {
        advertId: '廣告ID',
        adName: '廣告名稱',
        classify: '廣告分類',
        location: '投放位置',
        advertType: '發布類型',
        startTime: '投放時間',
        endTime: '結束時間',
        createTime: '創建時間'
      },
      advertType: {
        site: '站內',
        outside: '站外',
        noJump: '不跳轉'
      },
      location:{
        device: '設備',
        ownerHome: '業主家',
        businessHome: '商家家',
        serviceHome: '服務家',
        convenienceHome: '便利家',
        staffHome: '員工'
      },
      classify: {
        logistics: '物流',
        catering: '餐飲',
        travel: '旅遊',
        hotel: '酒店',
        education: '教育',
        internet: '互聯網'
      },
      add: {
        title: '發布廣告',
        adName: '廣告名稱',
        adNamePlaceholder: '必填，請填寫廣告名稱',
        classify: '廣告分類',
        classifyPlaceholder: '必填，請選擇廣告分類',
        locationTypeCd: '投放位置',
        locationPlaceholder: '必填，請選擇投放位置',
        advertType: '發布類型',
        advertTypePlaceholder: '必填，請選擇發布類型',
        pageUrl: '跳轉路徑',
        pageUrlPlaceholder: '請填寫跳轉路徑',
        seq: '播放順序',
        seqPlaceholder: '必填，請填寫播放順序',
        startTime: '投放時間',
        startTimePlaceholder: '必填，請填寫投放時間',
        endTime: '結束時間',
        endTimePlaceholder: '必填，請填寫結束時間',
        viewType: '播放方式',
        viewTypePlaceholder: '必填，請選擇播放方式',
        image: '圖片(800 * 373)',
        success: '廣告發布成功'
      },
      edit: {
        title: '修改廣告',
        adName: '廣告名稱',
        adNamePlaceholder: '必填，請填寫廣告名稱',
        classify: '廣告分類',
        classifyPlaceholder: '必填，請選擇廣告分類',
        locationTypeCd: '投放位置',
        locationPlaceholder: '必填，請選擇投放位置',
        advertType: '發布類型',
        advertTypePlaceholder: '必填，請選擇發布類型',
        pageUrl: '跳轉路徑',
        pageUrlPlaceholder: '請填寫跳轉路徑',
        seq: '播放順序',
        seqPlaceholder: '必填，請填寫播放順序',
        startTime: '投放時間',
        startTimePlaceholder: '必填，請填寫投放時間',
        endTime: '結束時間',
        endTimePlaceholder: '必填，請填寫結束時間',
        viewType: '播放方式',
        viewTypePlaceholder: '必填，請選擇播放方式',
        image: '圖片(800 * 373)',
        success: '廣告修改成功'
      },
      delete: {
        title: '請確認您的操作',
        confirm: '確定刪除發布廣告?',
        success: '廣告刪除成功'
      },
      machine: {
        title: '廣告設備碼',
        machineCode: '設備編碼',
        machineCodePlaceholder: '必填，請填寫設備編碼',
        view: '查看廣告'
      },
      validate: {
        adNameRequired: '廣告名稱不能為空',
        classifyRequired: '廣告分類不能為空',
        locationRequired: '投放位置不能為空',
        advertTypeRequired: '發布類型不能為空',
        seqRequired: '播放順序不能為空',
        seqNumber: '播放順序必須為數字',
        startTimeRequired: '開始時間不能為空',
        endTimeRequired: '結束時間不能為空',
        viewTypeRequired: '播放方式不能為空',
        imageRequired: '請上傳圖片',
        machineCodeRequired: '設備編碼不能為空'
      },
      fetchError: '獲取廣告列表失敗',
      fetchLocationError: '獲取位置類型失敗'
    }
  }
}